import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {SucursalesListComponent} from './sucursales-list.component';
import {SucursalesService} from './sucursales.service';
import {Observable} from 'rxjs/Observable';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {Negocio} from '../negocios/negocio';
import {NegociosService} from '../negocios/negocios.service';
import {CiudadesService} from '../ciudades/ciudades.service';
import {Ciudad} from '../ciudades/ciudad';

@Component({
  selector: 'pm-add-sucursal',
  templateUrl: './add-sucursal.component.html',
  styleUrls: ['./add-sucursal.component.sass']
})
export class AddSucursalComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'SUCURSALES';

  businessSelected: string;

  businessList: Observable<Negocio[]> = this.negociosService.allRecords();
  citiesList: Observable<Ciudad[]> = this.ciudadesService.allRecords();

  constructor(
    private parent: SucursalesListComponent,
    public service: SucursalesService,
    private negociosService: NegociosService,
    private ciudadesService: CiudadesService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null) {
      form.resetForm();
    }
    this.service.formData = {
      id: 0, // 204,
      name: '', // Adana Aguascalientes,
      nodeIdentifier: 0, // ,
      nodeKey: '', // ADAN,
      affiliationNumber1: '', // 7752377,
      affiliationNumber2: '', // 9353248330,
      status: 1, // ,
      street: '', // Av. Tecnologico,
      neighborhood: '', // Ejido Ojo Caliente,
      postalCode: '', // 20198,
      internalNumber: '', // ,
      externalNumber: '', // S/N,
      shopNumber: '', // F03,
      phone: '', // (449) 970-0737,
      cityId: '', // 111,
      cityName: '', // Aguascalientes,
      businessId: '', // 116,
      businessName: ''
    };
  }

  ngAfterViewInit() {
    $('a[rel=sucursales]').addClass('selected');
  }

  cancelSucursal(): void {
    this.parent.showSucursales = true;
    this.parent.showAddSucursal = false;
  }

  addSucursal(form: NgForm): void {
    console.log('addSucursal: form: ', form);
    if (form.invalid) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }

    form.value.businessId = parseInt(form.value.businessId);
    form.value.cityId = parseInt(form.value.cityId);

    this.parent.showSucursales = true;
    this.parent.showAddSucursal = false;
    this.service.addSucursal(this.service.formData).subscribe(
      res => {
        this.router.navigate(['/sucursales']);
      },
      err => console.log('addSucursal: err: ', err)
    );
  }

  ngOnDestroy() {
    $('a[rel=sucursales]').removeClass('selected');
  }
}
